import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { CheckBox, SubmitButton } from "../../components/Input";

const OfferForm = ({ id, services }) => {
  const navigate = useNavigate();

  const [offerData, setOfferData] = useState({
    offername: "",
    offercode: "",
    offervalue: "",
    startdate: null,
    enddate: null,
    minlimits: "",
    maxlimits: "",
    mincredits: "",
    maxcredits: "",
    serviceid: "",
    activate: 1,
    once_per_user: 1,
  });

  const [operation, setOperation] = useState("Add");
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (id) {
      setOperation("Edit");
      // Fetch the data for editing
      // You would typically replace this with an API call
      const fetchedOfferData = {
        offername: "Sample Offer",
        offercode: "CODE123",
        offervalue: "10%",
        startdate: new Date(),
        enddate: new Date(),
        minlimits: "100",
        maxlimits: "1000",
        mincredits: "10",
        maxcredits: "100",
        serviceid: "1",
        activate: 1,
        once_per_user: 1,
      };
      setOfferData(fetchedOfferData);
    } else {
      setOperation("Add");
    }

    if (id === 1 || id === 2) {
      setDisabled(true);
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOfferData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (date, field) => {
    setOfferData((prevState) => ({
      ...prevState,
      [field]: date,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can make an API call to save the data here
    console.log("Offer Data submitted:", offerData);
    Swal.fire("Success", "Offer saved successfully", "success");
    navigate("/Website/Offers"); // Redirect after success
  };

  const handleCancel = () => {
    navigate("/Website/Offers"); // Go back to offers list
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form
            onSubmit={handleSubmit}
            className="stdform"
            encType="multipart/form-data"
          >
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">{operation} Offers</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4 mt-2">
                  <label>Offer Name</label>
                  <input
                    type="text"
                    name="offername"
                    value={offerData.offername}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter Offer Name"
                    disabled={disabled}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label>Offer Code</label>
                  <input
                    type="text"
                    name="offercode"
                    value={offerData.offercode}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter Offer Code"
                    disabled={disabled}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label>Offer Value (in %)</label>
                  <input
                    type="text"
                    name="offervalue"
                    value={offerData.offervalue}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter Offer Value"
                    disabled={disabled}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label>Min. Amount Limit</label>
                  <input
                    type="text"
                    name="minlimits"
                    value={offerData.minlimits}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter Min. Amount Limit"
                    disabled={disabled}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label>Max. Amount Limit</label>
                  <input
                    type="text"
                    name="maxlimits"
                    value={offerData.maxlimits}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter Max. Amount Limit"
                    disabled={disabled}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label>Min. Credit Limit</label>
                  <input
                    type="text"
                    name="mincredits"
                    value={offerData.mincredits}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter Min. Credit Limit"
                    disabled={disabled}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label>Max. Credit Limit</label>
                  <input
                    type="text"
                    name="maxcredits"
                    value={offerData.maxcredits}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter Max. Credit Limit"
                    disabled={disabled}
                  />
                </div>
                {id !== 1 && id !== 2 && (
                  <div className="col-md-4 mt-2">
                    <label>Services</label>
                    <select
                      name="serviceid"
                      value={offerData.serviceid}
                      onChange={handleChange}
                      className="form-control"
                    >
                      {/* {services.map((service) => (
                        <option key={service.id} value={service.id}>
                          {service.name}
                        </option>
                      ))} */}
                    </select>
                  </div>
                )}
                <div className="col-md-4 mt-2">
                  <label>Start Date</label>
                  <DatePicker
                    selected={offerData.startdate}
                    onChange={(date) => handleDateChange(date, "startdate")}
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    disabled={disabled}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label>End Date</label>
                  <DatePicker
                    selected={offerData.enddate}
                    onChange={(date) => handleDateChange(date, "enddate")}
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    disabled={disabled}
                  />
                </div>
                {id !== 1 && id !== 2 && (
                  <>

                    <div className="col-md-4 mt-2 mb-2">
                      <CheckBox
                        label="Set Active"
                        fieldname="activate"
                        checked={offerData.activate === 1}
                        onChange={() =>
                          setOfferData((prevState) => ({
                            ...prevState,
                            activate:
                              prevState.activate === 1 ? 0 : 1,
                          }))
                        }
                      />
                    </div>
                    <div className="col-md-4 mt-2 mb-2">
                      <CheckBox
                        label="Once Per User"
                        fieldname="once_per_user"
                        checked={offerData.once_per_user === 1}
                        onChange={() =>
                          setOfferData((prevState) => ({
                            ...prevState,
                            once_per_user:
                              prevState.once_per_user === 1 ? 0 : 1,
                          }))
                        }
                      />
                    </div>
                  </>
                )}
                <div className="clearfix"></div>
                <div className="form-actions mt-4">
                  <SubmitButton />
                </div>{" "}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OfferForm;
